export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export const isStringOrNull = (value: unknown): value is string | null =>
  typeof value === "string" || value === null;

export const isNumberOrNull = (value: unknown): value is number | null =>
  typeof value === "number" || value === null;

export function fieldsMatch(
  value: Record<string, unknown>,
  keys: readonly string[],
  matches: (field: unknown) => boolean,
): boolean {
  return keys.every((key) => matches(value[key]));
}

export function optionalFields(
  value: Record<string, unknown>,
  keys: readonly string[],
  matches: (field: unknown) => boolean,
): boolean {
  return keys.every((key) => value[key] === undefined || matches(value[key]));
}

export async function validatedJson<T>(
  response: Response,
  matches: (value: unknown) => value is T,
  invalidMessage: string,
): Promise<T> {
  const value: unknown = await response.json();
  if (!matches(value)) throw new Error(invalidMessage);
  return value;
}
